import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './Section.module.scss';

interface Props {
  className?: string;
  children: ReactNode;
}

export function Section({ children, className }: Props) {
  return (
    <section className={clsx(styles.container, className)}>{children}</section>
  );
}
